import React, { ChangeEvent, useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CFormSelect,
  CSpinner,
} from '@coreui/react-pro'
import {
  $error,
  $translationItem,
  getTranslationItem,
  setError,
  submitUpdateService,
  translationItemMounted,
} from './model'
import { useStore, useUnit } from 'effector-react'
import { ServiceItem } from './types'
import { useNavigate, useParams } from 'react-router-dom'
import { languagesList } from '../../../clients/edit/consts'
import { Button, notification, Upload } from 'antd'
import { AxiosError } from 'axios'
import {
  $listLanguagesOfServices,
  getAllServiceLanguages,
  loadAllLanguages,
} from '../list/model'
import { path } from '../../../../libs'
import { validateJsonNoDuplicateKeys } from '../../../../libs/validateJsonNoDuplicateKeys'
import { NotificationPlacement } from 'antd/es/notification/interface'

export const EditService: React.FC = () => {
  const navigate = useNavigate()
  const [api, contextHolder] = notification.useNotification()

  const saveError = useUnit($error)

  const openNotification = (placement: NotificationPlacement) => {
    api.error({
      message: `Error`,
      description: `${saveError.message}`,
      placement,
    })
  }

  const [serviceForm, setServiceForm] = useState<ServiceItem>({
    service: '',
    lang: '',
    translations: {},
  })

  const listLanguagesOfServices = useUnit($listLanguagesOfServices)

  const translationItem = useStore($translationItem)
  const translationItemLoading = useStore(getTranslationItem.pending)
  const languagesLoading = useStore(getAllServiceLanguages.pending)
  const { serviceName, lang } = useParams()

  useEffect(() => {
    translationItemMounted()
  }, [lang])

  useEffect(() => {
    setServiceForm((prev) => ({
      ...prev,
      service: serviceName || '',
      lang: lang || '',
      translations: translationItem,
    }))
  }, [translationItem, serviceName, lang])

  useEffect(() => {
    if (saveError.code !== 0) {
      openNotification('topRight')
    }
  }, [saveError])

  useEffect(() => {
    if (!listLanguagesOfServices) {
      loadAllLanguages()
    }
  }, [listLanguagesOfServices])

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    let value = event.currentTarget.value

    if (serviceName && value) {
      navigate(path.translations.services.edit(serviceName, value))
    }
  }

  if (translationItemLoading || languagesLoading) {
    return <CSpinner />
  }

  return (
    <CCard className="mb-4">
      {contextHolder}
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Edit service</strong>
      </CCardHeader>
      <CCardBody>
        <CCol sm={5}>
          <CFormInput
            type="text"
            name="service"
            readOnly
            plainText
            value={serviceForm.service}
            label="Service"
            className="mb-3"
          />
        </CCol>
        {serviceName && listLanguagesOfServices && (
          <CCol sm={5} className="mb-3">
            <CFormSelect
              label="Language"
              name="lang"
              value={serviceForm.lang}
              onChange={handleChange}
            >
              {languagesList
                .filter((item) =>
                  listLanguagesOfServices[serviceName]?.includes(item.value),
                )
                .map((item) => (
                  <option value={item.value}>{item.label}</option>
                ))}
            </CFormSelect>
          </CCol>
        )}
        <CCol sm={12} className="mb-3">
          <div>Description</div>
          <pre>{JSON.stringify(serviceForm.translations, null, 4)}</pre>
        </CCol>
        <CCol sm={12}>
          <div className="d-flex justify-content-between">
            <Upload
              accept=".txt, .json"
              showUploadList={false}
              beforeUpload={(file) => {
                const reader = new FileReader()

                reader.onload = (e) => {
                  try {
                    // @ts-ignore
                    const translations = validateJsonNoDuplicateKeys(
                      e.target?.result as string,
                    )

                    setServiceForm((prevState) => ({
                      ...prevState,
                      translations,
                    }))
                  } catch (err) {
                    const error = err as AxiosError
                    setError({ message: error.message, code: 404 })
                  }
                }
                reader.readAsText(file)

                return false
              }}
            >
              <Button className="mb-3">Click to Upload</Button>
            </Upload>
            <CButton
              color="primary"
              className="mb-2 d-flex flex-end"
              onClick={() => submitUpdateService(serviceForm)}
            >
              Save
            </CButton>
          </div>
        </CCol>
      </CCardBody>
    </CCard>
  )
}
